/**
 * White label: applies the client's primary color to the presence screens
 * (--pv-brand) and picks a readable text color on top of it.
 */
function luminance(hex: string): number {
  const n = parseInt(hex.replace('#', ''), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function applyTheme(brand?: string): void {
  if (!brand || !/^#[0-9a-fA-F]{6}$/.test(brand)) return;
  const root = document.documentElement;
  root.style.setProperty('--pv-brand', brand);
  root.style.setProperty(
    '--pv-on-brand',
    luminance(brand) > 0.35 ? '#1F1400' : '#FFFFFF'
  );
}
